import { ReplaySubject, Subject, BehaviorSubject } from 'rxjs';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class EventService {
	public documentMouseUpEvent: ReplaySubject<MouseEvent> = new ReplaySubject<MouseEvent>(1);
	public documentFileDragging: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
	public dragStart: ReplaySubject<Event> = new ReplaySubject<Event>(1);
	public dragEnd: ReplaySubject<Event> = new ReplaySubject<Event>(1);
	public clipboardPasteSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

	private renderer: Renderer2;
	private windowDragOverListener: any;
	private windowDragging = new Subject();
	private dragStarted = false;

	constructor(private rendererFactory: RendererFactory2) {
		this.renderer = this.rendererFactory.createRenderer(null, null);

		this.renderer.listen(document, 'mouseup', (ev: MouseEvent) => {
			this.documentMouseUpEvent.next(ev);
		});

		this.renderer.listen(document, 'dragenter', (ev: DragEvent) => {
			if (this.dragStarted) {
				return;
			}
			this.documentFileDragging.next(true);
			if (!this.windowDragOverListener) {
				this.windowDragOverListener = this.renderer.listen(document, 'dragover', (dev: DragEvent) => {
					this.windowDragging.next(dev.type);
					dev.preventDefault();
				});
			}
		});

		this.renderer.listen(document, 'dragstart', (ev: Event) => {
			this.dragStart.next(ev);
			// drag started from within the document so it is not a file
			this.dragStarted = true;
		});

		this.renderer.listen(document, 'dragend', (ev: MouseEvent) => {
			this.dragEnd.next(ev);
			this.dragStarted = false;
		});

		this.renderer.listen(document, 'dragleave', (ev: MouseEvent) => {
			this.windowDragging.next(ev.type);
		});

		this.renderer.listen(document, 'drop', (ev: MouseEvent) => {
			this.windowDragging.next(ev.type);
		});

		this.windowDragging.pipe(
			debounceTime(1000)
		).subscribe((type) => {
			this.documentFileDragging.next(false);
			if (this.windowDragOverListener) {
				this.windowDragOverListener();
				this.windowDragOverListener = null;
			}
		});

		this.renderer.listen(document, 'paste', (ev: any) => {
			// get text without HTML
			const text = (ev.originalEvent || ev).clipboardData?.getData('text');
			if (
				text && ev && ev.srcElement && ev.srcElement.tagName
				&& ev.srcElement.tagName.toUpperCase() !== 'INPUT' && ev.srcElement.tagName.toUpperCase() !== 'TEXTAREA'
			) {
				this.clipboardPasteSubject.next(text);
			}
		});
	}
}
